import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
import { withRouter } from "react-router";
var qs = require("qs");
var Experts = /** @class */ (function (_super) {
    tslib_1.__extends(Experts, _super);
    function Experts(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            users: [],
            page: _this.props.history.location.search.split('=')[1] ? Number(_this.props.history.location.search.split('=')[1]) - 1 : 0,
            pageSize: 20,
            loading: true,
            currentUser: {},
            showRodal: false,
            query: '',
            filterIds: '',
        };
        return _this;
    }
    Experts.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.history.action === "POP") {
            var prevState = localStorage.getItem("experts-state");
            if (prevState) {
                var parsePrevState = JSON.parse(prevState);
                this.setState(tslib_1.__assign({}, parsePrevState, { page: this.props.history.location.search.split('=')[1] }), function () {
                    _this.getUsers();
                });
            }
            else {
                this.getUsers();
            }
        }
        else {
            this.getUsers();
        }
        localStorage.removeItem("experts-state");
    };
    Experts.prototype.componentWillUnmount = function () {
        console.log(this.state.dateFrom);
        localStorage.setItem("experts-state", JSON.stringify({
            filterIds: this.state.filterIds,
            page: this.state.page,
            pageSize: this.state.pageSize,
            query: this.state.query,
        }));
    };
    Experts.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.history.action === "POP") {
            this.setState({ page: this.props.history.location.search.split('=')[1] }, function () {
                _this.getUsers();
            });
        }
    };
    Experts.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'user_id',
                width: 100,
                style: { textAlign: 'center' }
            }, {
                Header: 'ФИО',
                accessor: 'fio',
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    var date = new Date(props.row._original.confirmed_at);
                    return (React.createElement("div", { className: "btn-group" }, (!date || date.getFullYear() < 1111) ? (React.createElement(React.Fragment, null,
                        React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row._original.user_id, 'approve'), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-thumbs-up" })),
                        React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row._original.user_id, 'decline'), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-thumbs-down" })))) : (React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row._original.user_id, 'decline'), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                        React.createElement("i", { className: "fa fa-user-slash" })))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438")),
                React.createElement("div", { className: "form-group" },
                    "ID",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "id", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                filterIds: value,
                            }, function () { return _this.getUsers(); });
                        }, value: this.state.filterIds, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0441\u043B\u043E\u0432\u0430\u043C",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "query", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                query: value,
                            }, function () { return _this.getUsers(); });
                        }, value: this.state.query, type: "text" }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.users, columns: columns })))));
    };
    Experts.prototype.getUsers = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        searchString += '&ids=' + this.state.filterIds + '&query=' + this.state.query + '&expert=true';
        axios.get(API_URL + '/users?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                users: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    Experts.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () {
            _this.getUsers();
            _this.addParamToUrl(page + 1);
        });
    };
    Experts.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getUsers(); });
    };
    Experts.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getUsers();
            _this.addParamToUrl(_this.state.page + 1);
        });
    };
    Experts.prototype.changeStatus = function (id, status) {
        var _this = this;
        var result = status === 'approve' ? confirm('Вы уверены, что хотите дать пользователю права эксперта?') : confirm('Вы уверены, что хотите лишить пользователя прав эксперта?');
        if (result) {
            axios.post(API_URL + '/user/expert/' + id, qs.stringify({
                status: status,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getUsers();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    Experts.prototype.addParamToUrl = function (param) {
        var url = '?page=' + param;
        this.props.history.push(url);
        return true;
    };
    return Experts;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(Experts));



//////////////////
// WEBPACK FOOTER
// ./src/views/experts/index.tsx
// module id = 531
// module chunks = 0